// import { cloneDeep } from 'lodash';

// const initialState = {
//   authenticated: false,
//   user: {
//     userId: null,
//     alias: null,
//     role: null,
//     placeId: null,
//   },
//   placeId: 'friendspub',
//   loading: false,
// };

const loading = (state, payload) => {
  const newState = {
    authenticated: state.authenticated,
    user: {
      userId: state.user.userId,
      alias: state.user.alias,
      role: state.user.role,
      placeId: state.user.placeId,
    },
    loading: payload.loading,
  };
  
  return newState;
};

export { loading };
